module.exports = function getResource(label, vars = []) {
    let resources = {
        tierCelebrationGift: 'Cadeau pour célébrer votre échelon'
    };

    return resources[label];
};
